import React from 'react'
import {
  Control,
  UseFormTrigger,
  UseFormGetValues,
  UseFormResetField,
  UseFormSetValue,
  Path,
  RegisterOptions,
} from 'react-hook-form'

import ConstructionYear from '../common/ConstructionYear'
import Floor from '../common/Floor'
import FloorType from '../common/FloorType'
import Wc from '../common/Wc'
import Elevator from '../common/Elevator'
import Alarm from '../common/Alarm'
import FireSafety from '../common/commercial/FireSafety'
import Spaces from '../common/commercial/Spaces'
import EntranceHeight from '../common/commercial/EntranceHeight'
import ParkingSlotsCar from '../common/commercial/ParkingSlotsCar'
import ParkingSlotsMotorcycle from '../common/commercial/ParkingSlotsMotorcycle'
import ParkingSlotsBoat from '../common/commercial/ParkingSlotsBoat'
import CarElevator from '../common/commercial/CarElevator'
import GasStation from '../common/commercial/GasStation'
import CarWash from '../common/commercial/CarWash'
import Cctv from '../common/Cctv'
import EnergyClass from '../common/EnergyClass'

import { FormValues } from '..'
interface Props {
  control: Control<FormValues>
  trigger?: UseFormTrigger<FormValues>
  getValues: UseFormGetValues<FormValues>
  resetField: UseFormResetField<FormValues>
  setValue: UseFormSetValue<FormValues>
  name?: Path<FormValues>
  rules?: RegisterOptions
}

const CommercialParkingFields = (props: Props) => {
  const { control, trigger, getValues, resetField, setValue } = props
  return (
    <>
      <ConstructionYear
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <EntranceHeight
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Floor
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Spaces
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ParkingSlotsCar
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ParkingSlotsMotorcycle
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <ParkingSlotsBoat
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Elevator
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CarElevator
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Wc
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <GasStation
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <CarWash
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <FireSafety
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Cctv
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <Alarm
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <EnergyClass
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
      <FloorType
        control={control}
        getValues={getValues}
        resetField={resetField}
        setValue={setValue}
        trigger={trigger}
      />
    </>
  )
}

export default React.memo(CommercialParkingFields)
